export default "__VITE_ASSET__DHWnIlXv__"